import { create } from "zustand";

import type { Tier } from "./read/readCoverage";

export type SavedDetails = {
  membershipId: string;
  name: { firstName: string; lastName: string } | null;
  dateOfBirth: string;
  memberId?: string;
};

type CoveragePlanStore = {
  /** The plan the user picked; undefined leads with the primary. */
  membershipId?: string;
  /** Undefined opens on the figure that decides. */
  tier?: Tier;
  /** A plan whose details were just saved, until a check answers again. */
  detailsSaved?: string;
  /** What that save sent, so editing again starts from it. */
  savedDetails?: SavedDetails;
  /** When that save landed, while the re-check it starts may still arrive. */
  checkingSince?: number;
  select: (membershipId: string) => void;
  pickTier: (tier: Tier) => void;
  markDetailsSaved: (
    membershipId: string | undefined,
    details?: SavedDetails,
  ) => void;
  stopChecking: () => void;
};

export const useCoveragePlanStore = create<CoveragePlanStore>(set => ({
  membershipId: undefined,
  tier: undefined,
  select: membershipId => set({ membershipId }),
  pickTier: tier => set({ tier }),
  markDetailsSaved: (membershipId, details) =>
    set(
      details
        ? {
            detailsSaved: membershipId,
            savedDetails: details,
            checkingSince: Date.now(),
          }
        : { detailsSaved: membershipId, checkingSince: undefined },
    ),
  stopChecking: () => set({ checkingSince: undefined }),
}));
